import ENDPOINTS from 'api/endpoints';
import type { IntegrationFormConfig } from '../types';
import { transformPhoneNumberPatternErrors } from '../utils/errorTransformers';
import { createPhoneNumbersDataSource } from '../utils/phoneNumbersDataSource';

const PHONE_NUMBER_WITH_COUNTRY_CODE_PATTERN = '^\\+[1-9]\\d{6,14}$';

export const fiveNineFormConfig: IntegrationFormConfig = {
  steps: [
    {
      title: 'Step 1: Configure Five9',
      description:
        'Configure the routing from Five9 to PolyAI. Pseudo numbers are provided by the Five9 SIP trunk provisioning team. Use the Call Handoff page to configure SIP transfers back to Five9.',
      dataSource: createPhoneNumbersDataSource('five9'),

      schema: {
        required: ['sandbox', 'prerelease', 'live'],
        type: 'object',
        properties: {
          sandbox: {
            type: 'array',
            title: 'Sandbox',
            items: {
              minLength: 4,
              type: 'string',
              pattern: PHONE_NUMBER_WITH_COUNTRY_CODE_PATTERN,
            },
            default: [],
          },
          prerelease: {
            type: 'array',
            title: 'Pre-release',
            items: {
              minLength: 4,
              type: 'string',
              pattern: PHONE_NUMBER_WITH_COUNTRY_CODE_PATTERN,
            },
            default: [],
          },
          live: {
            type: 'array',
            title: 'Live',
            items: {
              minLength: 4,
              type: 'string',
              pattern: PHONE_NUMBER_WITH_COUNTRY_CODE_PATTERN,
            },
            default: [],
          },
        },
      },
      uiSchema: {
        sandbox: {
          'ui:widget': 'TagInputWidget',
          'ui:patternErrorMessage':
            'Please enter a valid phone number with country code (e.g. +441234567890)',
        },
        prerelease: {
          'ui:widget': 'TagInputWidget',
          'ui:patternErrorMessage':
            'Please enter a valid phone number with country code (e.g. +441234567890)',
        },
        live: {
          'ui:widget': 'TagInputWidget',
          'ui:patternErrorMessage':
            'Please enter a valid phone number with country code (e.g. +441234567890)',
        },
      },
      transformErrors: errors => {
        const newErrors = transformPhoneNumberPatternErrors(errors);
        return newErrors;
      },
    },
  ],
  onSubmit: {
    path: `${ENDPOINTS.TELEPHONY_GATEWAY_PROXY}/five9`,
    data: ['sandbox', 'prerelease', 'live'],
  },
};
